import { IProgramItem } from '../../../../../types/interfaces/program-item';
import { IUser } from '../../../../../types/interfaces/user';
import { getUserViewName } from '../../../../../utils/common/shared-util';

export type ProgramListKind = 'my' | 'available';

export type ProgramListSubtitleIcon = 'fromPerson' | 'forPerson' | 'sharedBy';

export interface IProgramListSubtitle {
  icon: ProgramListSubtitleIcon;
  label: string;
}

/**
 * Subtitle under the program title (icon + line), same rules as trainings list.
 */
export function getProgramListSubtitle(
  programItem: IProgramItem,
  currentUser: IUser | undefined,
  listKind: ProgramListKind,
): IProgramListSubtitle | null {
  if (!currentUser?.id) {
    return null;
  }

  if (listKind === 'available') {
    if (!programItem.owner) {
      return null;
    }
    return {
      icon: 'sharedBy',
      label: getUserViewName(programItem.owner),
    };
  }

  const creatorIsAnotherUser =
    !!programItem.creator?.id && programItem.creator.id !== currentUser.id;

  if (creatorIsAnotherUser && programItem.creator) {
    return {
      icon: 'fromPerson',
      label: getUserViewName(programItem.creator),
    };
  }

  return null;
}

/**
 * View screen: show who the program is from when it is not «mine» by owner/creator.
 */
export function getProgramItemViewSubtitle(
  programItem: IProgramItem,
  currentUser: IUser | undefined,
): IProgramListSubtitle | null {
  if (!currentUser?.id) {
    return null;
  }

  if (programItem.owner?.id && programItem.owner.id !== currentUser.id) {
    return {
      icon: 'sharedBy',
      label: getUserViewName(programItem.owner),
    };
  }

  if (programItem.creator?.id && programItem.creator.id !== currentUser.id) {
    return {
      icon: 'fromPerson',
      label: getUserViewName(programItem.creator),
    };
  }

  return null;
}
